import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "../../services/fetchApi";

export const useSearchActivites = (search: string) => {
  const promise = () => fetchApi("/api/activites", { method: "get", query: { libelle: search } });
  return useQuery<Awaited<ReturnType<typeof promise>>, Error>(["search_activites", search], promise, {
    enabled: search !== "",
  });
};
